module.exports = __webpack_public_path__ + "static/media/all-lens.346e8e4c.png";